<template>
	<div class="style style-one" :id="classId">
		<ul class="overflow ">
			<li class="style-li pull-l"></li>
			<li class="style-li pull-l"></li>
			<li class="style-li pull-l"></li>
			<li class="style-li pull-l"></li>
			<li class="style-li pull-l"></li>
		</ul>
		<ul class="overflow margin-top">
			<li class="style-li pull-l"></li>
			<li class="style-li pull-l"></li>
			<li class="style-li pull-l"></li>
			<li class="style-li pull-l"></li>
			<li class="style-li pull-l"></li>
		</ul>
		<ul class="overflow margin-top">
			<li class="style-li pull-l"></li>
			<li class="style-li pull-l"></li>
			<li class="style-li pull-l"></li>
			<li class="style-li pull-l"></li>
			<li class="style-li pull-l"></li>
		</ul>
		<ul class="overflow margin-top">
			<li class="style-li pull-l"></li>
			<li class="style-li pull-l"></li>
			<li class="style-li pull-l"></li>
			<li class="style-li pull-l"></li>
			<li class="style-li pull-l"></li>
		</ul>
	</div>
</template>

<script>
	
	export default {
		name: '',
		components: {
			
		},
		props: ["classId"],
		data() {
			return{
				
			}
		}
	};
</script>

<style scoped>
	
	.margin-top{
		margin-top:10rem
	}
	.style-li:last-child{
		margin-right:0 !important;
	}
	.style{
		width:54rem;
	}
	.style .style-li{
		width:6rem;
		height:13rem;
		background: #D2DCF3;
		margin-right:5rem;
	}
</style>